import React from "react";
import { Row, Col, Modal, Button } from "antd";
import Styles from "../components/PersonMatch/PersonMatch.module.scss";
import CrossMark from "../assets/images/CrossMark.png";

type Props = {
  isAccountFound: boolean;
  handleWandaLogin: () => void;
  handleAccountFoundCancel: () => void;
};

const MTMAccountExistsModal: React.FC<Props> = ({
  isAccountFound,
  handleWandaLogin,
  handleAccountFoundCancel,
}) => {
  return (
    <Modal
      className={Styles.accountExistsModalContainer}
      visible={isAccountFound}
      centered={true}
      width="unset"
      footer={
        <Row justify="center">
          <Col>
            <Button id={Styles.accountExistsBtn} onClick={handleWandaLogin}>
              Okay
            </Button>
          </Col>
        </Row>
      }
    >
      <div>
        <img
          src={CrossMark}
          alt="CrossMark"
          className="modalPopUpCloseIcon"
          onClick={handleAccountFoundCancel}
        />
      </div>
      <Row justify="center">
        <Col
          span={24}
          className={`${"subTextFont"} ${Styles.accountExistsModalDescription}`}
        >
          Looks like you have an existing account with our parent company, MTM.
          <div className={Styles.accountExistsLineBreak}>
            &nbsp;Please login to Wanda using your MTMLink email address and
            password.
          </div>
        </Col>
      </Row>
    </Modal>
  );
};
export default MTMAccountExistsModal;
